// extracted by mini-css-extract-plugin
export var chip = "_cj-0";
export var filterDropdown = "_cj-5";
export var filterItem = "_cj-6";
export var icon = "_cj-1";
export var removeButton = "_cj-3";
export var removeIcon = "_cj-4";
export var separator = "_cj-2";